import Navbar from "../../../../components/Shared/Navbar";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import Header from "../../../../components/Shared/Header";
import AdminNavbar from "../../../../components/Shared/AdminNavbar";
import { useEffect } from "react";
import { partnerDetails, createActionOf } from "../../../../store/actions/ActionCreator";
import { COUNTRY_CODE_AND_NAME_REQUESTED } from "../../../../store/actions/ActionType";

const NavbarContainer = (props) => {
  const dispatch = useDispatch();

  const response = useSelector((state) => {
    return {
      partnerDetails: state.partnerDetailsReducer.partnerDetails,
      isVIAdmin: state.partnerDetailsReducer.isVIAdmin,
      isVIDotgoAdmin: state.partnerDetailsReducer.isVIDotgoAdmin,
      profileCompleted: state.partnerDetailsReducer.profileCompleted,
      partnerProfileImage: state.partnerDetailsReducer.partnerProfileImage,
      isMarketingAdmin: state.partnerDetailsReducer?.isMarketingAdmin,
      isDotgoAdmin: state.partnerDetailsReducer?.isDotgoAdmin,
      countryCodeAndName: state.countryCodeAndNameReducer?.data
    };
  }, shallowEqual);

  useEffect(() => {
    // if (!response.partnerDetails) {
    //   dispatch(partnerDetails());
    // }
    if(!response.countryCodeAndName){
      dispatch(createActionOf(COUNTRY_CODE_AND_NAME_REQUESTED, 0));
    }
  }, []);
  return response.partnerDetails && response.countryCodeAndName ? (
    <>
      {response.partnerDetails.isCarrier ||
      response.isVIAdmin ||
      response.isVIDotgoAdmin === true ? (
        <AdminNavbar
          partnerDetails={response.partnerDetails}
          profileCompleted={response.profileCompleted}
          partnerProfileImage={response.partnerProfileImage}
          isVIDotgoAdmin={response.isVIDotgoAdmin}
          isVIAdmin={response.isVIAdmin}
          isDotgoAdmin={response.isDotgoAdmin}
        />
      ) : response.isMarketingAdmin ? (
        <Header />
      ) : (
        <Navbar
          partnerDetails={response.partnerDetails}
          isDataPresent={
            response.partnerDetails === "basic details not present"
          }
          profileCompleted={response.profileCompleted}
          partnerProfileImage={response.partnerProfileImage}
          isMarketingAdmin={response.isMarketingAdmin}
        />
      )}
    </>
  ) : (
    <Header />
  );
};
export default NavbarContainer;
